import { put, takeLatest, call } from 'redux-saga/effects';
import {
  LOADER_STOP,
  ASSESSEE_CONFIRM_SAGA,
  SET_ASSESSEE_PERMISSION,
  SET_SELECTED_ASSOCIATE,
  SET_DISPLAY_TWO_SINGLE_STATE,
  SET_USER,
  SET_USER_STATE,
  ASSESSEE_ASSOCIATE_LINK_LIST,
  REVIEWLIST_DISTINCT_DATA,
  SET_MIDDLEPANE_STATE,
  POPUP_CLOSE,
  ASSESSEE_ASSOCIATE_LINK_REVISE_SAGA,
  SET_POPUP_VALUE,
  RESET_ALL_REDUCER,
  CLEAR_PANE_TWO_REDUCER,
  CLEAR_ASSESSEE_ASSESSMENT_REDUCER_STATE
} from '../../actionType';
import { PLATFORM_MODULE_URL, SIGN_IN_URL } from '../../endpoints';
import { EXCEPTION_ERROR_MESSAGE } from '../../errorMessage';

const assesseesConfirmApi = async (requestObj) => {
  const requestOptions = {
    method: 'POST',
    headers: new Headers({
      Authorization: localStorage.getItem('token')
    }),
    body: JSON.stringify(requestObj.data)
  };
  const response = await fetch(requestObj.URL, requestOptions);
  const json = await response.json();
  return json;
};

function* workerConfirmAssesseeSaga(data) {
  try {
    const response = yield call(assesseesConfirmApi, {
      data: data.payload.requestObject,
      // URL: CONFIRM_ASSESSEE_URL
      URL: PLATFORM_MODULE_URL
    });
    // const response = {
    //   responseCode: '008',
    //   responseMessage: '',
    //   responseObject:
    //     'Already found an entry for the provided username. (Service: AWSCognitoIdentityProvider; Status Code: 400; Error Code: AliasExistsException; Request ID: e5c579a0-3e58-4185-9aa1-da91ce448794; Proxy: null)'
    // };
    if (response.responseCode === '000') {
      localStorage.setItem('token', response?.responseObject?.cognitoResponse?.accessToken);
      localStorage.setItem('refreshToken', response?.responseObject?.cognitoResponse?.refreshToken);
      yield put({ type: SET_USER, payload: response?.responseObject?.signInResponse });
      yield put({
        type: SET_DISPLAY_TWO_SINGLE_STATE,
        payload: {
          stateName: 'signInRes',
          value: response?.responseObject
        }
      });
      yield put({
        type: SET_SELECTED_ASSOCIATE,
        payload: ''
      });
      yield put({
        type: SET_ASSESSEE_PERMISSION,
        payload: ''
      });
      yield put({
        type: SET_USER_STATE,
        payload: { stateName: 'assesseeConfirmStatus', value: 'confirmSuccess' }
      });
      localStorage.setItem('userConfirmed', 'true');
    } else if (response.responseCode === '007') {
      yield put({
        type: SET_USER_STATE,
        payload: { stateName: 'assesseeConfirmStatus', value: 'confirmErrorLinked' }
      });
    } else if (response.responseCode === '008') {
      yield put({
        type: SET_USER_STATE,
        payload: { stateName: 'assesseeConfirmStatus', value: 'signInInformationExist' }
      });
    } else if (response.responseCode === '006') {
      yield put({
        type: SET_USER_STATE,
        payload: { stateName: 'assesseeConfirmStatus', value: 'incorrectInformation' }
      });
    } else if (response.responseCode === '123') {
      yield put({
        type: SET_USER_STATE,
        payload: { stateName: 'assesseeConfirmStatus', value: 'assesseeStatusIsInactive' }
      });
      yield put({
        type: SET_USER_STATE,
        payload: { stateName: 'responseMessage', value: response.responseMessage }
      });
    } else if (response.responseCode === '124') {
      yield put({
        type: SET_USER_STATE,
        payload: { stateName: 'assesseeConfirmStatus', value: 'assesseeStatusIsInactive' }
      });
      yield put({
        type: SET_USER_STATE,
        payload: { stateName: 'responseMessage', value: response.responseMessage }
      });
    } else {
    }
    yield put({ type: LOADER_STOP });
  } catch (e) {
    console.log('ERROR==', e);
    yield put({
      type: SET_POPUP_VALUE,
      payload: { isPopUpValue: EXCEPTION_ERROR_MESSAGE, popupMode: 'responseErrorMsg' }
    });
    yield put({ type: LOADER_STOP });
  }
}
function* workerAssesseeAssociateLinkSaga(data) {
  try {
    const response = yield call(assesseesConfirmApi, {
      data: data.payload.request,
      // URL: ASSESSEE_LINK_URL
      URL: PLATFORM_MODULE_URL
    });
    if (response.responseCode === '000') {
      yield put({ type: POPUP_CLOSE });
      console.log('response+++', response.responseObject);
      yield put({ type: REVIEWLIST_DISTINCT_DATA, payload: response.responseObject });
      yield put({
        type: SET_MIDDLEPANE_STATE,
        payload: {
          middlePaneHeader: 'associates',
          middlePaneHeaderBadgeOne: 'active',
          middlePaneHeaderBadgeTwo: '',
          middlePaneHeaderBadgeThree: '',
          middlePaneHeaderBadgeFour: '',
          typeOfMiddlePaneList: 'assesseeassociatesReviewList',
          scanCount: response?.countTotal || 0,
          showMiddlePaneState: true
        }
      });
      yield put({
        type: SET_DISPLAY_TWO_SINGLE_STATE,
        payload: { stateName: 'isSelectActive', value: 'multiple' }
      });
      console.log('success==', response.responseObject);
    } else {
      yield put({
        type: SET_DISPLAY_TWO_SINGLE_STATE,
        payload: { stateName: 'errorResponse', value: response }
      });
    }
    yield put({ type: LOADER_STOP });
  } catch (e) {
    console.log('ERROR==', e);
    yield put({
      type: SET_POPUP_VALUE,
      payload: { isPopUpValue: EXCEPTION_ERROR_MESSAGE, popupMode: 'responseErrorMsg' }
    });
    yield put({ type: LOADER_STOP });
  }
}
function* workerAssesseeAssociateLinkReviseSaga(data) {
  console.log('WATCH+++', data.payload.request);
  try {
    const response = yield call(assesseesConfirmApi, {
      data: data.payload.request,
      // URL: LINKED_ASSOCIATE_URL
      URL: PLATFORM_MODULE_URL
    });
    if (response.responseCode === '000') {
      console.log(response);
      yield put({
        type: SET_DISPLAY_TWO_SINGLE_STATE,
        payload: { stateName: 'errorResponse', value: response }
      });
      yield put({ type: LOADER_STOP });
      localStorage.clear();
      yield put({ type: RESET_ALL_REDUCER });
      yield put({ type: CLEAR_PANE_TWO_REDUCER });
      yield put({ type: CLEAR_ASSESSEE_ASSESSMENT_REDUCER_STATE });
      window.open(SIGN_IN_URL, '_self');
    } else {
      yield put({
        type: SET_POPUP_VALUE,
        payload: { isPopUpValue: response.responseMessage, popupMode: 'responseErrorMsg' }
      });
    }
    yield put({ type: LOADER_STOP });
  } catch (e) {
    console.log('ERROR==', e);
    yield put({
      type: SET_POPUP_VALUE,
      payload: { isPopUpValue: EXCEPTION_ERROR_MESSAGE, popupMode: 'responseErrorMsg' }
    });
    yield put({ type: LOADER_STOP });
  }
}

export default function* watchConfirmAssesseeSaga() {
  yield takeLatest(ASSESSEE_CONFIRM_SAGA, workerConfirmAssesseeSaga);
  yield takeLatest(ASSESSEE_ASSOCIATE_LINK_LIST, workerAssesseeAssociateLinkSaga);
  yield takeLatest(ASSESSEE_ASSOCIATE_LINK_REVISE_SAGA, workerAssesseeAssociateLinkReviseSaga);
}
